import { HomeOutlined, LoadingOutlined, LogoutOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Header } from "antd/lib/layout/layout";
import { ReactComponent as Logo } from "../../cti-logo_court.svg";
import React from "react";
import { logoutUser } from "../../redux/actions/keycloakActions";

function CtiHeader(props) {
  const loading = useSelector((state) => state.keycloak.loading);
  const dispatch = useDispatch();
  return (
    <Header>
      <Link to="/home" className="home-link" aria-label="Accueil" title="Accueil">
        <HomeOutlined />
      </Link>
      <Logo
        style={{
          width: "100px",
          height: "46px",
          marginLeft: "auto",
        }}
      />
      <Button
        type="link"
        className="connect-link"
        onClick={() => dispatch(logoutUser())}
      >
        <LogoutOutlined style={{ marginRight: 8 }} />
        {loading ? <LoadingOutlined spin /> : "Se Déconnecter"}
      </Button>
    </Header>
  );
}

export default CtiHeader;
